import type { Carer } from '@lmc/ts-common'
import _ from 'lodash'

export type SortKey =
  | 'recently-added'
  | 'first-added'
  | 'first-name-asc'
  | 'first-name-desc'

export const DEFAULT_SORT: SortKey = 'recently-added'

export const sortCarers = (carers: Carer[], sortKey: SortKey): Carer[] => {
  switch (sortKey) {
    case 'recently-added':
      return _.orderBy(carers, (c) => c.createdOn, 'desc')
    case 'first-added':
      return _.orderBy(carers, (c) => c.createdOn, 'asc')
    case 'first-name-asc':
      return _.orderBy(
        carers,
        (c) => (c.name?.first ?? '').toLowerCase(),
        'asc'
      )
    case 'first-name-desc':
      return _.orderBy(
        carers,
        (c) => (c.name?.first ?? '').toLowerCase(),
        'desc'
      )
    default: {
      const _exhaustive: never = sortKey
      return _exhaustive
    }
  }
}
